import { User } from "lucide-react"
import CommentForm from "./CommentForm"
import { getCommentProductsById } from "@/core/lib/api/main/main-shop-product"
import CommentList from "./CommnetList"
import { getDictionaryServer } from "@/core/lib/dictionary"

export interface CommentItem {
  id: number
  author_name: string
  created_at: string
  created_at_jalali?: string
  subject?: string
  content: string
}

interface ProductCommentsProps {
  productId: number
}

export default async function ProductComments({
  productId,
}: ProductCommentsProps) {
  const comments = await getCommentProductsById(productId);
  const { dictionary } = await getDictionaryServer()

  return (
    <div className="flex flex-col gap-8">
      {/* Header */}


      <CommentForm productId={productId} comments={comments} />

      {/* Comments list */}
      {comments.length === 0 ? (
        <div className="py-12 flex flex-col items-center gap-3 text-center">
          <div className="w-12 h-12 rounded-full bg-secondary flex items-center justify-center">
            <User className="w-5 h-5 text-primary-600" />
          </div>
          <p className="text-sm text-primary-600">{dictionary.ui?.pages.alertforcomment}</p>
        </div>
      ) : (
        <CommentList
          comments={comments}
        />
      )}
    </div>
  )
}